import React from 'react';
import clsx from 'clsx';
import { T } from '@colonist/ui';
import styles from './UIGameActionBoxBase.module.scss';
import IconCheck from '@static/images/icon_check.svg';
import IconX from '@static/images/icon_x.svg';
import BgButton from '@static/images/bg_button.svg';
const CloseButton = ({ onClick })=>/*#__PURE__*/ React.createElement("div", {
        className: styles.closeButton,
        onClick: onClick
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.buttonBackground,
        draggable: false,
        src: BgButton
    }), /*#__PURE__*/ React.createElement("img", {
        className: styles.buttonIcon,
        draggable: false,
        src: IconX
    }));
export const UIGameActionBoxBase = (props)=>{
    const { isVisible = true, title, body, imagePath, children, className, footerContent, titleClassName } = props;
    if (!isVisible) return null;
    const confirmationButtons = props.isInfoOnly ? /*#__PURE__*/ React.createElement(CloseButton, {
        onClick: props.onClose
    }) : /*#__PURE__*/ React.createElement(React.Fragment, null, props.onClose && /*#__PURE__*/ React.createElement(CloseButton, {
        onClick: props.onClose
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.confirmButton, {
            [styles.faded]: props.isConfirmDisabled
        }),
        onClick: props.isConfirmDisabled ? undefined : props.onConfirm
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.buttonBackground,
        draggable: false,
        src: BgButton
    }), /*#__PURE__*/ React.createElement("img", {
        className: styles.buttonIcon,
        draggable: false,
        src: IconCheck
    })));
    const hasFooterContent = footerContent != undefined;
    const hasBodyContent = children != undefined;
    const showButtonsInHeader = !hasFooterContent && !hasBodyContent;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.actionBox, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.header
    }, /*#__PURE__*/ React.createElement("img", {
        className: styles.headerImage,
        src: imagePath
    }), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.title, titleClassName)
    }, /*#__PURE__*/ React.createElement(T, {
        id: title
    })), /*#__PURE__*/ React.createElement("p", {
        className: styles.body
    }, /*#__PURE__*/ React.createElement(T, {
        id: body
    }))), showButtonsInHeader && /*#__PURE__*/ React.createElement("div", {
        className: styles.headerConfirmationButtons
    }, confirmationButtons)), children != undefined && /*#__PURE__*/ React.createElement("div", {
        className: styles.interactiveBody
    }, children, !hasFooterContent && /*#__PURE__*/ React.createElement("div", {
        className: styles.bodyConfirmationButtons
    }, confirmationButtons)), hasFooterContent && /*#__PURE__*/ React.createElement("div", {
        className: styles.footer
    }, footerContent, /*#__PURE__*/ React.createElement("div", {
        className: styles.footerConfirmationButtons
    }, confirmationButtons)));
};
